import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Search } from 'lucide-react'

function NavbarButtons() {
  const navigate = useNavigate()
  const [searchValue, setSearchValue] = useState('')

  function handleSearchKey(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      const q = searchValue.trim()
      if (q) {
        navigate(`/wire/search-results?q=${encodeURIComponent(q)}`)
        setSearchValue('')
      }
    }
  }

  return (
    <div className="relative">
      <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-fg-secondary pointer-events-none" aria-hidden="true" />
      <input
        type="search"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        placeholder="Search…"
        className="h-8 w-72 rounded-full bg-fill pl-8 pr-3 text-xs text-fg placeholder:text-fg-secondary outline-none focus:ring-1 focus:ring-solid"
        onKeyDown={handleSearchKey}
      />
    </div>
  )
}

export default NavbarButtons
